"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductsPage = void 0;
var Products_1 = require("./Products");
Object.defineProperty(exports, "ProductsPage", { enumerable: true, get: function () { return Products_1.ProductsPage; } });
